if (!customElements.get("make-model-year-search")) {
  customElements.define(
    "make-model-year-search",
    class YearSearch extends HTMLElement {
      constructor() {
        super();
        console.log("here in constructor")
        this.yearStoreData = "";
        this.yearFilter = this.querySelector(".select__year_data");
        this.yearFilter?.addEventListener(
          "change",
          this.getMakeData.bind(this)
        );
        this.ymmeFilter = this.querySelector(".select__ymme_data");
        this.getFilterURL = "";
        this.makeFilter = this.querySelector(".select__make_data");
        this.makeFilter?.addEventListener(
          "change",
          this.getModelData.bind(this)
        );
        this.modelStoreData = "";
        this.modelFilter = this.querySelector(".select__model_data");
        this.modelFilter?.addEventListener(
          "change",
          this.getEngineData.bind(this)
        );
        this.engineStoreData = "";
        this.engineFilter = this.querySelector(".select__engine_data");
        this.engineFilter?.addEventListener(
          "change",
          this.submitEngineData.bind(this)
        );
        this.searchButton = this.querySelector(".search__url");
        this.searchButton?.addEventListener("click", this.handleSearch.bind(this));
        this.searchURL = this.querySelector(".search__url");
        this.initMakeFilter();
        this.initYearfilter();
      }

      // Get initial Year data
  initMakeFilter() {
    // Create an array of years from 2025 to 1980
    let yearArray = [];
    for (let year = 2025; year >= 1980; year--) {
      yearArray.push(year);
    }

    // Create the options for the year selector
    let yearOptions = `<option value="select">${window.advanceSearch.field_label_3}</option>`;
    yearArray.forEach((year) => {
        yearOptions += `<option value="${year}">${year}</option>`;
    });

    // Update the makeFilter innerHTML with year options
    this.yearFilter.innerHTML = yearOptions;
  }
      
    // Get Model data
    getModelData(e) {
  
      let selectMakeValue = this.makeFilter.options[this.makeFilter.selectedIndex].value;
      let selectYearValue =  this.yearFilter.options[this.yearFilter.selectedIndex].value;
      const models = this.carData.filter(item => item.year === parseInt(selectYearValue) && item.make === selectMakeValue).map(item => item.model);
    
      // Remove duplicates by converting to a Set, then back to an array
      const uniqueModels = [...new Set(models)];
  
      // If models exist for the selected make, update the modelFilter options

      if (uniqueModels ) {
          let initialData = `<option value="select">${window.advanceSearch.field_label_2}</option>`;
      
          // Loop through the models and add them to the select dropdown
          uniqueModels.forEach((model) => {
              initialData += `<option value="${model}">${model}</option>`;
          });
        
        // Update the modelFilter with the new options and enable it
        this.modelFilter.innerHTML = initialData;
        this.modelFilter.disabled = false;
        this.yearFilter.disabled = false;
    }
  }

  // Get Engine data
  getMakeData(year) {
      
    //Hayk this URL has to be changed 
    const url = "https://cdn.shopify.com/s/files/1/0727/6249/1106/files/car_data.json?v=1743488888";

    // Fetch the car data from the JSON file
    fetch(url)
          .then(response => {
              console.log("response ", response);
              if (!response.ok) {
                  console.log("response is not valid");
                  throw new Error('Network response was not ok');
              }
          
              return response.json(); // Return the parsed JSON to the next .then()
          })
          .then(data => {
              // Work with the data here, where it’s available
            
              this.carData = data; // Assuming this is within an object/class context
           

            // Get unique makes for the selected year
              // Filter car data by the selected year
             let selectYearValue =
           this.yearFilter.options[this.yearFilter.selectedIndex].value;
            console.log("year ", selectYearValue)
            const filteredData = this.carData.filter(car => car.year === parseInt(selectYearValue));
            const uniqueMakes = [...new Set(filteredData.map(car => car.make))]
            console.log("unique makes ", uniqueMakes)
             let initialData = `<option value="select">${window.advanceSearch.field_label_1}</option>`;

            uniqueMakes.forEach((option) => {
              initialData += `<option value="${option}">${option}</option>`;
            });

            this.makeFilter.disabled = false;
            this.yearFilter.disabled = false;
            this.makeFilter.innerHTML = initialData;
            
        })
        .catch(err => console.log("we have error ", err));
}

      // Get Engin data
      getEngineData(e) {
        console.log("here in get engine file ")
        let selectMakeValue = this.makeFilter.options[this.makeFilter.selectedIndex].value;
        let selectYearValue =  this.yearFilter.options[this.yearFilter.selectedIndex].value;
        let selectModelValue = this.modelFilter.options[this.modelFilter.selectedIndex].value;
        console.log(" make ", selectMakeValue, "model ",selectModelValue, " year ", selectYearValue  )
        const engines = this.carData.filter(item => item.year === parseInt(selectYearValue) && item.make === selectMakeValue && item.model == selectModelValue).map(item => item.engines);
         console.log("engnes ",engines )
        const flattenedEngines = engines.flat(); // Flattens the array of arrays
        const uniqueEngines = [...new Set(flattenedEngines)]; // Removes duplicates using a Set
        let initialData = `<option value="select">${window.advanceSearch.field_label_4}</option>`;
        // Step 3: Loop through the unique engines and add them to the select dropdown
        uniqueEngines.forEach((engine) => {
              initialData += `<option value="${engine}">${engine}</option>`;
        });

        this.engineFilter.innerHTML = initialData;
        this.engineFilter.disabled = false;
      }

      // Submit Engine Data
    /*  submitEngineData(e) {
        let selectEngineValue = this.engineFilter.options[this.engineFilter.selectedIndex].value;
        this.getFilterURL = `/collections/all?filter.p.m.engine.key_engine=${selectEngineValue}&filter.p.m.year.key_year=${this.engineStoreData}&filter.p.m.model.key_model=${this.yearStoreData}&filter.p.m.make.key_make=${this.modelStoreData}`;
        this.searchURL.setAttribute("href", this.getFilterURL);
      }*/

  submitEngineData(e) {
    let selectEngineValue = this.engineFilter.options[this.engineFilter.selectedIndex].value;
    let selectMakeValue = this.makeFilter.options[this.makeFilter.selectedIndex].value;
    let selectYearValue =  this.yearFilter.options[this.yearFilter.selectedIndex].value;
    let selectModelValue = this.modelFilter.options[this.modelFilter.selectedIndex].value;

    // Store selections for use in handleSearch
  this.selectedValues = {
    year: selectYearValue,
    make: selectMakeValue,
    model: selectModelValue,
    engine: selectEngineValue
  };
  }
    handleSearch(e) {
  e.preventDefault(); // Prevent any default button behavior

  const { year, make, model, engine } = this.selectedValues || {};

  if (!year || !make || !model || !engine) {
    alert("Please complete all selections.");
    return;
  }
     // window.location.href = `/pages/compatibility?year=${year}&make=${make}&model=${model}&engine=${encodeURIComponent(engine)}`;
const searchURL = `/search?q=*&type=product&year=${year}&make=${make}&model=${model}&engine=${engine}`;
  window.location.href = searchURL;
  // Option 1: Redirect to a search URL (Shopify-style filtering)
 // const searchURL = `/search?year=${year}&make=${make}&model=${model}&engine=${engine}`;
//  window.location.href = searchURL;
     // const searchURL = `/search?q=*&type=product&year=${year}&make=${make}&model=${model}&engine=${engine}`;
 // window.location.href = searchURL

  // Option 2: Filter products on the current page (see Step 3)
  // this.filterProducts(year, make, model, engine);
}
    // Assuming: engineStoreData=Year, modelStoreData=Make, yearStoreData=Model
    //const searchString = `${selectYearValue}-${selectMakeValue}-${selectModelValue}-${selectEngineValue}`;
    //console.log(" string ",searchString )
    //this.getFilterURL = `/collections/all?filter.p.m.ymme.key_ymme=${searchString}`;
    //this.getFilterURL = `/collections/all?filter.p.m.ymme.key_ymme=${searchString}|filter.p.m.ymme1.key_ymme1=${searchString}|filter.p.m.ymme2.key_ymme2=${searchString}`;
    //console.log(" URL ", this.getFilterURL)
    //this.searchURL.setAttribute("href", this.getFilterURL);
   // const searchString = `${selectYearValue}-${selectMakeValue}-${selectModelValue}-${selectEngineValue}`;
   // this.getFilterURL = `/collections/all?q=${searchString}`;
    //window.location.href = this.getFilterURL;
   // this.searchURL.setAttribute("href", this.getFilterURL);
 // }

})
}
